<sc-modal>
  <div class="flex justify-between mb-6">
    <h3 class="text-mobileH3 tablet:text-tabletH3 desktop:text-desktopH3 font-headline">
      {{
        'components.activateSimInfoModal.label'
          | scTranslate: { substitution: Substitutions.UserName, subValue: userFirstName() }
          | async
      }}
    </h3>
    <sc-button variant="text" [padding]="false" (click)="close(false)">
      <sc-svg name="cross" size="w-8 h-8"></sc-svg>
    </sc-button>
  </div>
  <div class="font-semibold mb-1"></div>
  <p class="font-semibold">
    {{ 'components.activateSimInfoModal.title' | scTranslate | async }}
  </p>
  <p class="text-secondaryText">
    {{ 'components.activateSimInfoModal.subTitle1' | scTranslate | async }}
  </p>
  <p class="text-secondaryText mt-3">
    {{ 'components.activateSimInfoModal.subTitle2' | scTranslate | async }}
  </p>
  <sc-modal-footer>
    <div class="grid tablet:grid-cols-2 gap-2">
      <sc-button variant="alternate" (click)="close(false)">
        <span>
          {{ 'shared.later' | scTranslate | async }}
        </span>
      </sc-button>
      <sc-button variant="primary" (click)="close(true)">
        <span>
          {{ 'shared.activate' | scTranslate | async }}
        </span>
      </sc-button>
    </div>
  </sc-modal-footer>
</sc-modal>
